export const WORKSPACE_ACCESS_DENIED = 'workspace access denied';
export const INTERNAL_ERROR_RETRY_LATER =
  'Internal error, please retry later or contact our support';
export const INVALID_VIDEO_ID = 'Invalid videoId provided';
export const INVALID_VIDEO_ID_FETCH_TRANSCRIPT =
  'Invalid videoId supplied for fetching transcript';
export const NO_TRANSCRIPT_ASSOCIATED_WITH_VIDEO =
  'No transcript associated with video';
export const NO_VIDEO_TRANSCRIPT_FOUND = 'No video transcript found';
export const VIEWER_DOES_NOT_HAVE_PERMISSION =
  'Viewer does not have permission';
export const UPDATE_FILLER_WORD_REMOVAL_DENIED =
  'Update Filler Word Removal Denied';
export const UPDATE_TRANSCRIPT_DENIED = 'Update Transcript Denied';
export const REVERT_CORRECTIONS_DENIED = 'Update Transcript Denied';

// Overrides
export class InvalidMemberOverrideRequestError extends Error {
  constructor(message) {
    super(message);
    this.name = 'InvalidMemberOverrideRequestError';
  }
}

export class LoomGraphQLError extends Error {
  /**
   * Construct a loom gql error
   * @param {string} message Error message
   * @param {string} [typename] Gql __typename
   */
  constructor(message, typename) {
    super(message);
    this.name = LoomGraphQLError.name;

    if (typeof typename === 'string') {
      this.typename = typename;
    }
  }
}

export class ClipUpdateError extends Error {
  static REASONS = {
    NOT_V6: 'NOT_V6',
    NO_CLIPS: 'NO_CLIPS',
    DUPLICATE_ENTRIES: 'DUPLICATE_ENTRIES',
    BAD_POSITION: 'BAD_POSITION',
    UNMATCHED_CLIP: 'UNMATCHED_CLIP',
    OVER_DURATION: 'OVER_DURATION',
  };

  constructor(reason, message, ...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ClipUpdateError);
    }

    this.name = 'ClipUpdateError';
    this.reason = reason;
    this.message = message;
  }
}
